// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
    width: 300px;
    margin: 0 2rem;
}

.section-item {
    background-color: #fff;
    border: 1px solid var(--therapist-border-color);
    border-radius: 6px;
    padding: 10px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.section-item:hover {
    background-color: var(--therapist-hover-bg);
    border-color: var(--therapist-accent-color);
}

.section-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: var(--therapist-text-color);
}

.completion-check {
    color: var(--therapist-highlight-color);
    font-size: 16px;
}

.section-item.active {
    background-color: var(--therapist-accent-color);
    border-color: var(--therapist-accent-color);
    color: #fff;
}

.section-item.active .section-content > p {
    color: #fff;
}

.summary-item {
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./app/components/therapist/medical-history/styles/SectionList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,+CAA+C;IAC/C,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,+CAA+C;IAC/C,2CAA2C;IAC3C,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gEAAgE;AACpE","sourcesContent":[".section-list {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    width: 300px;\n    margin: 0 2rem;\n}\n\n.section-item {\n    background-color: #fff;\n    border: 1px solid var(--therapist-border-color);\n    border-radius: 6px;\n    padding: 10px 20px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.section-item:hover {\n    background-color: var(--therapist-hover-bg);\n    border-color: var(--therapist-accent-color);\n}\n\n.section-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 14px;\n    color: var(--therapist-text-color);\n}\n\n.completion-check {\n    color: var(--therapist-highlight-color);\n    font-size: 16px;\n}\n\n.section-item.active {\n    background-color: var(--therapist-accent-color);\n    border-color: var(--therapist-accent-color);\n    color: #fff;\n}\n\n.section-item.active .section-content > p {\n    color: #fff;\n}\n\n.summary-item {\n    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
